import { render, staticRenderFns } from "./OurValues.vue?vue&type=template&id=27098d37&scoped=true"
var script = {}
import style0 from "./OurValues.vue?vue&type=style&index=0&id=27098d37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27098d37",
  null
  
)

export default component.exports